import styled from '@emotion/styled';

export const CustomCalendarStyle = styled.div`
    .fc-theme-bootstrap5 .fc-scrollgrid,
    .fc-theme-bootstrap5 td,
    .fc-theme-bootstrap5 th {
        border: none;
    }

    .fc .fc-popover-header {
        background-color: white;
        border: none;
    }

    .fc-h-event {
        background-color: transparent;
        border-color: transparent;
    }

    .fc-day-disabled {
        background: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.1));
    }

    .fc-toolbar-title {
        font-size: 0.75rem;
    }

    /* FIX CALENDAR CUTTING */
    .fc,
    .fc-media-screen,
    .fc-view-harness,
    .fc-view-harness-active {
        height: auto !important;
    }

    .fc .fc-scroller-liquid-absolute {
        overflow: visible !important;
    }

    .fc-scroller {
        overflow: visible !important;
    }

    .fc-more-link {
        font-size: 12px;
    }

    .fc-header-toolbar.fc-toolbar.fc-toolbar-ltr {
        position: absolute;
        top: 5px;
        right: 10rem;
        display: flex;
        flex-direction: row-reverse;
        margin-bottom: 0;
    }

    /* IMPORTANT */
    .fc .fc-daygrid-day-frame {
        min-height: 160px;
        height: 100%;
        //ex  height: auto;
        border: 1px solid #eeeeee;
    }

    #influencer-calendar .fc-header-toolbar.fc-toolbar.fc-toolbar-ltr {
        top: 10px;
        right: 84%;
        width: 100%;
    }

    #influencer-calendar .fc-event-main:hover {
        background: #eeeeee;
        border-radius: 0.25rem;
    }

    /* REMOVE HARD LIMIT */
    #influencer-calendar.mixed-calendar .fc.fc-media-screen {
        overflow-y: visible;
        max-height: unset;
    }

    .fc-toolbar-chunk {
        margin-left: 0.5rem;
    }

    .fc .fc-daygrid-day.fc-day-today {
        background-color: transparent;
    }
    .fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-frame {
        border: 1px solid #05bbc9 !important;
        border-radius: 6px;
    }
    .fc-scroller-harness {
        padding: 0.5rem 0;
        border-top: 1px solid #eeeeee;
        border-left: 1px solid #eeeeee;
        border-right: 1px solid #eeeeee;
        overflow: visible !important;
    }

    .fc-scrollgrid-section-header div {
        overflow: hidden !important;
    }

    .btn-group button:not(:first-of-type) {
        margin-left: 1rem;
    }
    .fc .fc-scrollgrid-section-sticky > * {
        z-index: 2 !important;
    }
    .fc-daygrid-day-number {
        font-weight: 500;
        color: #2e3033;
        font-size: 14px;
    }
    .fc .fc-day-today .fc-daygrid-day-number {
        font-weight: 800;
    }
    .btn {
        box-shadow: 1px 1px 4px #0000001a;
        border-radius: 8px;
        background: #ffffff 0% 0% no-repeat padding-box;
        border-color: #80808014;
        color: #2e3033 !important;
    }

    .btn.active,
    .btn-primary:active {
        background: #ffffff 0% 0% no-repeat padding-box !important;
        border-color: #80808014 !important;
        color: #05bbc9 !important;
        font-weight: 600 !important;
    }

    .btn:hover {
        background: #ffffff 0% 0% no-repeat padding-box;
        color: #05bbc9 !important;
    }

    .fc-event-main p {
        color: #2e3033;
    }

    a.fc-daygrid-event.fc-daygrid-block-event.fc-h-event.fc-event.fc-event-start.fc-event-end.fc-event-future:hover {
        background: rgba(0, 0, 0, 0.1);
    }

    @media (max-width: 768px) {
        .fc-view-harness-active {
            min-height: 720px !important;
            height: auto !important;
        }
    }

    @media (max-width: 1200px) {
        .fc-header-toolbar.fc-toolbar.fc-toolbar-ltr {
            position: static;
            flex-direction: column;
            top: 0;
            margin-bottom: 0.5rem;
        }

        .fc-toolbar-title {
            margin-top: 0.5rem;
        }
    }

    .calendar-event-content {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 4px 8px;
        background: white;
        border-radius: 6px;
        border-left: 3px solid;
        transition: all 0.2s ease;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
    }

    .event-status-icon {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        font-size: 10px;
    }

    .event-info {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 6px;
        min-width: 0;
        width: 100%;
    }

    .event-name {
        font-size: 12px;
        font-weight: 400;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .event-icon img {
        width: 20px !important;
        height: 20px !important;
        object-fit: contain;
    }
    .event-icon-global img {
        width: 30px !important;
        height: 30px !important;
        object-fit: contain;
    }
`;
